import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { makeVoiceRequest } from '../requestUtils';
import styles from './navigation-handler.module.scss';
//@ts-ignore
import toWav from 'audiobuffer-to-wav';
import { SnackBarContext } from '@frontend-workspace/react-shared-lib';

/* eslint-disable-next-line */
export interface NavigationHandlerProps { }

export function NavigationHandler(props: NavigationHandlerProps) {
  const navigate = useNavigate();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const audioContext = new AudioContext();
  const mediaRecorderRef = useRef<any>(null);
  const audioChunksRef = useRef<any[]>([]);

  useEffect(() => {
    let isRouteNavigation = false;
    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
      mediaRecorderRef.current = new MediaRecorder(stream, { mimeType: 'audio/webm' });
      mediaRecorderRef.current.ondataavailable = (event: { data: any; }) => {
        audioChunksRef.current.push(event.data);
      };
      mediaRecorderRef.current.onstop = () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
        const formData = new FormData();
        formData.append('audio', audioBlob);
        formData.append('currentPath', window.location.pathname);
        makeVoiceRequest(`GPT/voiceNavigation`, formData).then((result: any) => {
          navigate(result.url);
          setSnackbarMessage({ content: result.userMessage, type: 'info' });
        });

        audioChunksRef.current = [];
      };
    });
    const handleKeyDown = (e: any) => {
      if (e.ctrlKey && e.altKey) {
        isRouteNavigation = true;
        onStartRecorder();
      }
      if (e.ctrlKey && e.shiftKey) {
        isRouteNavigation = false;
        onStartRecorder();
      }
    };

    const handleKeyUp = (e: any) => {
      if (e.key === 'Control') {
        onStopRecorder();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, []);
  const onStartRecorder = () => {
    if (mediaRecorderRef.current.state !== 'recording') {
      mediaRecorderRef.current.start();
    }
  };
  const onStopRecorder = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
      mediaRecorderRef.current.stop(); // Stopping the media recorder
    }
  }
  return (
    <div className={styles['container']}>
    </div>
  );
}
export default NavigationHandler;
